import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import ProfessorValidation from "../ValidationScheema/ProfessorValidation";
import { signupUser } from "../Store/api/auth";
import { useFormik } from "formik";
import SideBar from "./SideBar";
import { useNavigate, Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import storage from "../services/storage";
import Loader from "../components/Loader";
import DraggableSidebar from "../components/DraggableSidebar";
const initialValues = {
  firstName: "",
  lastName: "",
  university: "",
  email: "",
  password: "",
  confirmPassword: "",
};

function ProfessorSignup() {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const [, setErrMessage] = useState({});
  const [errorMessage, setErrorMessage] = useState({
    type: "success",
    message: "",
  });

  useEffect(() => {
    const token = storage.get("xAuthToken");
    if (token) {
      navigate("/home", { replace: true });
    }
  }, []);
  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: ProfessorValidation,
      onSubmit: (values, action) => {
        setLoading(true);

        dispatch(
          signupUser({
            body: {
              firstName: values.firstName,
              lastName: values.lastName,
              university: values.university,
              email: values.email,
              password: values.password,
              role: "PROFESSOR",
            },
            onSuccess: (res) => {
              if (res.data.data.role === "PROFESSOR") {
                navigate("/signup/createClass", { replace: true });
              } else {
                navigate("/home", { replace: true });
              }
              // navigate("/professorSignin", {replace: true});
              setLoading(false);
              //toast.success("Welcome!!");
              action.resetForm();
            },

            onError: (err) => {
              setLoading(false);

              setErrorMessage({
                type: "danger",
                message: err.response ? err.response.data.message : err.message,
              });
              setErrMessage(
                err.response ? err.response.data.message : err.message
              );
              //toast.error(err.response.data.message);
            },
          })
        );
      },
    });

  return (
    <div className="flex-container">
      <div
        // className="col-xxl-1 col-xl-1 col-lg-12 col-md-12 px-0"
        className="activity-spectrum"
      >
        <div>
          <DraggableSidebar
          /*  scrollBook={scrollToSection}
                  scrollCentre={scrollWithSpectrum} */
          />
        </div>
      </div>
      <div style={{ width: "100%" }}>
        <section className="class_room_wrap">
          <div className="custom_container">
            <div className="row">
              <div className="col-xxl-3 col-xl-5 col-lg-5 col-md-12 px-0   pb-0">
                <SideBar bookRol="professor" tabContents="class" />
              </div>
              <div
                className="col-xxl-6 col-xl-7 col-lg-7 col-md-12"
                style={{ width: "52%" }}
              >
                <div
                  className="welcome_wrap cursor_default"
                  style={{ height: "calc(87vh - 68px)", top: "15%" }}
                >
                  <h1
                    className="main_title mb-4 pt-100 "
                    style={{ overflowX: "scroll" }}
                  >
                    welcome,{" "}
                    {!values.firstName ? (
                      <>professor</>
                    ) : (
                      <>{values.firstName}</>
                    )}
                  </h1>
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="First name"
                            name="firstName"
                            value={values.firstName}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            autoComplete="off"
                          />{" "}
                          <div className="err-end">
                            {errors.firstName && touched.firstName ? (
                              <p className="error-msg">{errors.firstName}</p>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Last name"
                            name="lastName"
                            value={values.lastName}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            autoComplete="off"
                          />{" "}
                          <div className="err-end">
                            {errors.lastName && touched.lastName ? (
                              <p className="error-msg">{errors.lastName}</p>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <input
                            type="university"
                            className="form-control"
                            name="university"
                            placeholder="University"
                            value={values.university}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            autoComplete="off"
                          />{" "}
                          <div className="err-end">
                            {errors.university && touched.university ? (
                              <p className="error-msg">{errors.university}</p>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <input
                            type="email"
                            className="form-control"
                            name="email"
                            placeholder="University email address"
                            value={values.email}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            autoComplete="off"
                          />{" "}
                          <div className="err-end">
                            {errors.email && touched.email ? (
                              <p className="error-msg">{errors.email}</p>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <input
                            type="Password"
                            className="form-control"
                            placeholder="Password"
                            name="password"
                            value={values.password}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            autoComplete="off"
                          />{" "}
                          <div className="err-end">
                            {errors.password && touched.password ? (
                              <p className="error-msg">{errors.password}</p>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <input
                            type="Password"
                            className="form-control"
                            placeholder="Confirm password"
                            name="confirmPassword"
                            value={values.confirmPassword}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            autoComplete="off"
                          />{" "}
                          <div className="err-end">
                            {errors.confirmPassword &&
                            touched.confirmPassword ? (
                              <p className="error-msg">
                                {errors.confirmPassword}
                              </p>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      {/*                     {loading ? (
                      <div>
                        <div className="spinner"></div>
                      </div>
                    ) : ( */}
                      <div className="col-lg-12">
                        <div className="btn_Wrap mt-30">
                          <button
                            type="submit"
                            className="btn_black_theme w-100 d-block"
                            disabled={loading ? true : false}
                          >
                            {loading ? (
                              <div className="loader">
                                <Loader />
                              </div>
                            ) : (
                              " Sign up"
                            )}
                          </button>
                          {/* <ToastContainer /> */}
                          <p className="agrre-to mt-20 pb-55 pdl-8">
                            By signing up, you agree to be contacted by greyled
                            and its partners.{" "}
                            <a href="https://greyled.com" className="font-whi">
                              Learn more
                            </a>
                          </p>
                          <div>
                            {" "}
                            {errorMessage.message && (
                              <div
                                className={`alert alert-${errorMessage.type}`}
                              >
                                {errorMessage.message}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      {/*   )} */}
                    </div>
                  </form>
                </div>
                <div
                  className="col-12"
                  style={{
                    paddingLeft: "96px",
                    position: "absolute",
                    bottom: "30px",
                    width: "30%",
                  }}
                >
                  <div className="footer_bottom">
                    <p className="have-account">
                      Already have an account? <Link to={"/"}>Sign in</Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
export default ProfessorSignup;
